import React from "react";
import { FormattedMessage } from "react-intl";

import ToggleCard from "./ToggleCard";

const SUPPORT_QUESTIONS = [
  {
    title: "SUPPORT_TITLE_ADDRESS",
    questions: ["SUPPORT_QUESTION_ADDRESS"],
    answers: [
      {
        answer: "SUPPORT_ANSWER_ADDRESS",
        values: {
          email: <a href="#">administratie@cnb.nl</a>
        }
      }
    ]
  },
  {
    title: "SUPPORT_TITLE_LOGIN",
    questions: [
      "SUPPORT_QUESTION_PASSWORD",
      "SUPPORT_QUESTION_CHANGE_PASSWORD",
      "SUPPORT_QUESTION_ACCESS",
      "SUPPORT_QUESTION_TERMINATE_ACCESS"
    ],
    answers: [
      {
        answer: "SUPPORT_ANSWER_PASSWORD",
        values: {
          imageOne: (
            <div className="centered-img">
              <img src="/assets/images/support/password.png" />
            </div>
          ),
          imageTwo: (
            <div className="centered-img">
              <img src="/assets/images/support/password2.png" />
            </div>
          )
        }
      },
      {
        answer: "SUPPORT_ANSWER_CHANGE_PASSWORD"
      },
      {
        answer: "SUPPORT_ANSWER_ACCESS",
        values: {
          imageOne: (
            <div className="centered-img">
              <img src="/assets/images/support/access.png" />
            </div>
          ),
          imageTwo: (
            <div className="centered-img">
              <img src="/assets/images/support/access2.png" />
            </div>
          ),
          imageThree: (
            <div className="centered-img">
              <img src="/assets/images/support/access3.png" />
            </div>
          )
        }
      },
      {
        answer: "SUPPORT_ANSWER_TERMINATE_ACCESS"
      }
    ]
  },
  {
    title: "SUPPORT_TITLE_DOCUMENT",
    questions: ["SUPPORT_QUESTION_SEEN"],
    answers: [
      {
        answer: "SUPPORT_ANSWER_SEEN",
        values: {
          imageOne: (
            <div className="centered-img">
              <img src="/assets/images/support/document.png" />
            </div>
          ),
          imageTwo: (
            <div className="centered-img">
              <img src="/assets/images/support/document2.png" />
            </div>
          ),
          list: (
            <ul>
              <FormattedMessage id="MARK_AS_READ" tagName="li" />
              <FormattedMessage id="MARK_AS_UNREAD" tagName="li" />
              <FormattedMessage id="OPEN_PDF" tagName="li" />
            </ul>
          )
        }
      }
    ]
  },
  {
    title: "SUPPORT_TITLE_ORDERS",
    questions: ["SUPPORT_QUESTION_ORDERS"],
    answers: [
      {
        answer: "SUPPORT_ANSWER_ORDERS",
        values: {
          imageOne: (
            <div className="centered-img">
              <img src="/assets/images/support/orders.png" />
            </div>
          ),
          imageTwo: (
            <div className="centered-img">
              <img src="/assets/images/support/orders2.png" />
            </div>
          )
        }
      }
    ]
  },
  {
    title: "SUPPORT_TITLE_SEARCH",
    questions: ["SUPPORT_TITLE_SEARCH"],
    answers: [
      {
        answer: "SUPPORT_ANSWER_SEARCH",
        values: {
          image: (
            <div className="centered-img">
              <img src="/assets/images/support/search.png" />
            </div>
          )
        }
      }
    ]
  },
  {
    title: "SUPPORT_TITLE_DELIVERIES",
    questions: [
      "SUPPORT_QUESTION_DELIVERIES",
      "SUPPORT_QUESTION_GROWER",
      "SUPPORT_QUESTION_REPORT",
      "SUPPORT_QUESTION_CHAIN_REGISTER",
      "SUPPORT_QUESTION_BATCH_DATA",
      "SUPPORT_QUESTION_ALL_DELIVERIES",
      "SUPPORT_QUESTION_CORRECTION",
      "SUPPORT_QUESTION_DONT",
      "SUPPORT_QUESTION_ARRIVED",
      "SUPPORT_QUESTION_CNB",
      "SUPPORT_QUESTION_OTHER"
    ],
    answers: [
      {
        answer: "SUPPORT_ANSWER_DELIVERIES"
      },
      {
        answer: "SUPPORT_ANSWER_GROWER"
      },
      {
        answer: "SUPPORT_ANSWER_REPORT"
      },
      {
        answer: "SUPPORT_ANSWER_CHAIN_REGISTER",
        values: {
          link: <a href="www.ketenregister.nl">www.ketenregister.nl</a>
        }
      },
      {
        answer: "SUPPORT_ANSWER_BATCH_DATA",
        values: {
          link: <a href="www.ketenregister.nl">www.ketenregister.nl</a>
        }
      },
      {
        answer: "SUPPORT_ANSWER_ALL_DELIVERIES"
      },
      {
        answer: "SUPPORT_ANSWER_CORRECTION"
      },
      {
        answer: "SUPPORT_ANSWER_DONT"
      },
      {
        answer: "SUPPORT_ANSWER_ARRIVED"
      },
      {
        answer: "SUPPORT_ANSWER_CNB"
      },
      {
        answer: "SUPPORT_ANSWER_OTHER"
      }
    ]
  }
];

const Support = () => (
  <div className="tab1">
    <div className="column">
      {SUPPORT_QUESTIONS.slice(0, 5).map(support => (
        <React.Fragment key={support.title}>
          <FormattedMessage id={support.title} tagName="h3" />
          {support.questions.map((question, index) => (
            <ToggleCard key={index} title={question}>
              <FormattedMessage
                id={support.answers[index].answer}
                values={support.answers[index].values}
              />
            </ToggleCard>
          ))}
        </React.Fragment>
      ))}
    </div>
    <div className="column">
      <FormattedMessage id={SUPPORT_QUESTIONS[5].title} tagName="h3" />
      {SUPPORT_QUESTIONS[5].questions.map((q, i) => (
        <ToggleCard key={i} title={q}>
          <FormattedMessage
            id={SUPPORT_QUESTIONS[5].answers[i].answer}
            values={SUPPORT_QUESTIONS[5].answers[i].values}
          />
        </ToggleCard>
      ))}
    </div>
  </div>
);

export default Support;
